import type { OrganizationRef } from '@viewer/protocol';
import { useState, type FormEvent } from 'react';
import { Modal } from '../../ui/Modal';
import styles from './UnattendedConfirmDialog.module.css';

const CONFIRM_WORD = 'CONFIRMAR';

interface Props {
  organization: OrganizationRef;
  onConfirm(): void;
  onCancel(): void;
}

/** Liberar uma empresa para entrar sem supervisão exige digitar a palavra de confirmação. */
export function UnattendedConfirmDialog({ organization, onConfirm, onCancel }: Props) {
  const [typed, setTyped] = useState('');
  const matches = typed.toLowerCase() === CONFIRM_WORD.toLowerCase();

  function submit(e: FormEvent) {
    e.preventDefault();
    if (matches) onConfirm();
  }

  return (
    <Modal title="Tem certeza?" eyebrow="Acesso sem supervisão" onClose={onCancel}>
      <form className={styles.form} onSubmit={submit}>
        <p className={styles.text}>
          Ao ativar esta opção, a empresa <strong>{organization.name}</strong> poderá acessar este computador a qualquer
          momento, sem que você precise aprovar ou esteja presente. Ela poderá ver sua tela e controlar o computador.
          Você pode desativar a qualquer momento.
        </p>
        <label className={styles.label} htmlFor="unattended-confirm">
          Para continuar, digite <strong>{CONFIRM_WORD}</strong>
        </label>
        <input
          id="unattended-confirm"
          className={styles.input}
          autoComplete="off"
          autoFocus
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
        />
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={onCancel}>
            Cancelar
          </button>
          <button type="submit" className={styles.primary} disabled={!matches}>
            Permitir acesso sem supervisão
          </button>
        </div>
      </form>
    </Modal>
  );
}
